import { Asterisk } from "lucide-react";

const ITEMS = [
  "Miti e Realtà",
  "Trattamenti",
  "Organizzazione del Tempo",
  "Gestione dello Spazio",
  "Relazioni Interpersonali",
  "Cura di Sé e Autostima",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-2xl italic text-[#FAF8F5]/90 sm:text-3xl">
          {item}
        </span>
        <Asterisk className="h-5 w-5 shrink-0 text-[#14B8A6]" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="marquee-strip"
    className="relative overflow-hidden border-y border-[#14B8A6]/20 bg-[#0C1B33] py-5"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
